<template>
  <div class="topBar">
    <el-button size="large" type="primary" @click="dialogVisible2 = true"
      >添加优惠卷</el-button
    >
  </div>
  <el-table
    :data="tableData"
    :border="parentBorder"
    :preserve-expanded-content="preserveExpanded"
    style="width: 100%"
  >
    <el-table-column type="expand">
      <template #default="props">
        <div m="4">
          <el-row :gutter="16" justify="center">
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              type="flex"
              align="middle"
              class="text-center mb-4"
            >
              <el-statistic title="优惠卷数目" :value="props.row.data.length" />
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              type="flex"
              align="middle"
              class="text-center mb-4"
            >
              <el-statistic
                :value="
                  props.row.data.filter((item) => item.isUse !== 0).length
                "
              >
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    已使用
                  </div>
                </template>
              </el-statistic>
            </el-col>
          </el-row>
          <el-table :data="props.row.data" :border="childBorder">
            <el-table-column label="游戏" prop="gameName" />
            <el-table-column label="抵消金额(元)" prop="discountAmount" />
            <el-table-column label="用户Id" prop="userId" />
            <el-table-column label="状态">
              <template #default="{ row }">
                <el-tag
                  size="large"
                  :type="row.isUse == 0 ? 'warning' : 'success'"
                  >{{ row.isUse == 0 ? "未使用" : "已使用" }}</el-tag
                >
              </template> </el-table-column
            >>
            <el-table-column label="密钥" prop="secretKey" />
          </el-table>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="备注" prop="remark" />
    <el-table-column label="过期时间" prop="expirationTime" />
    <el-table-column fixed="right" label="编辑" min-width="120" align="right">
      <template #default="props">
        <el-button
          link
          type="primary"
          size="small"
          @click="
            dialogVisible = true;
            selectRemark = props.row.remark;
          "
        >
          删除
        </el-button>
        <el-button
          link
          type="primary"
          size="small"
          @click="
            selectRemark = props.row.remark;
            exportExcel();
          "
        >
          导出Excel
        </el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-dialog v-model="dialogVisible" width="500" draggable :show-close="false">
    <el-form :model="form" label-width="auto" style="max-width: 600px">
      <el-checkbox-group v-model="checkList">
        <el-checkbox label="删除所有" value="1" />
        <el-checkbox label="删除已使用优惠卷" value="2" />
        <el-checkbox label="删除未领取的优惠卷" value="3" />
      </el-checkbox-group>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="delTicket"> 删除 </el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogVisible2" width="500" draggable :show-close="false">
    <el-form :model="form" label-width="auto" style="max-width: 600px">
      <el-form-item label="游戏(多选)">
        <el-select
          v-model="value1"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="搜索游戏"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 240px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="折扣金额">
        <el-input
          v-model="form.discountAmount"
          type="number"
          max="1000"
          @blur="handleDiscountBlur"
        />
      </el-form-item>

      <el-form-item label="过期时间">
        <el-date-picker
          v-model="form.expirationTime"
          type="datetime"
          placeholder="Pick a day"
          @change="changeTime"
        />
      </el-form-item>
      <el-form-item label="卷数">
        <el-input
          v-model="voucherNum"
          type="number"
          max="300"
          @blur="handleDiscountBlur"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          type="text"
          maxlength="30"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="addVoucher"> 添加 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { ElMessage } from "element-plus";
import { formatDateTime } from "../../utils/index.js";
import { downloadFile } from "@/utils/index2";
import { requestByGet } from "@/api/globalApi";

export default {
  name: "DemoPage",
  data() {
    return {
      tableData: [],
      parentBorder: false,
      childBorder: false,
      dialogVisible: false,
      dialogVisible2: false,
      preserveExpanded: false,
      checkList: [],
      value1: [],
      options: [],
      selectRemark: "",
      form: {
        discountAmount: 1,
        expirationTime: "",
        gameId: "",
        gameName: "",
        isUse: 0,
        remark: "",
      },
      loading: false,
      voucherNum: 1,
    };
  },
  created() {
    this.fetchTickets();
  },
  computed: {},
  methods: {
    fetchTickets() {
      this.dialogVisible2 = false;
      this.dialogVisible = false;
      this.$store
        .dispatch("user/getTickets", {})
        .then((res: any) => {
          console.log(res);
          this.tableData = res;
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "error",
          });
        });
    },
    remoteMethod(query: string) {
      if (query) {
        this.loading = true;
        this.$store
          .dispatch("user/searchGame", { gameTitle: query })
          .then((res: any) => {
            console.log(res);
            this.options = res.map((item: any) => {
              return {
                value: item.id + "," + item.gameTitle,
                label: item.gameTitle,
              };
            });
            this.loading = false;
          })
          .catch((err: any) => {
            ElMessage({
              message: err,
              type: "error",
            });
          });
      } else {
        this.options.value = [];
      }
    },
    addVoucher() {
      if (!this.value1 || this.value1.length === 0) {
        this.form.gameId = "";
        this.form.gameName = "";
        ElMessage({
          message: "游戏不能为空",
          type: "warning",
        });
        return;
      }

      this.form.gameId = this.value1
        .map((item: any) => item.split(",")[0])
        .join(",");
      this.form.gameName = this.value1
        .map((item: any) => item.split(",")[1])
        .join(",");

      this.$store
        .dispatch("user/addTickets", {
          params: { voucherNum: this.voucherNum },
          data: this.form,
        })
        .then((res: any) => {
          ElMessage({
            message: "添加成功",
            type: "success",
          });
          this.fetchTickets();
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "error",
          });
        });
    },
    handleDiscountBlur() {
      let num1 = Number(this.form.discountAmount);
      if (num1 > 1000) this.form.discountAmount = 1000;
      if (num1 <= 0) this.form.discountAmount = 1;

      let num2 = Number(this.voucherNum);
      if (num2 > 300) this.voucherNum = 300;
      if (num2 <= 0) this.voucherNum = 1;
    },
    changeTime() {
      this.form.expirationTime = formatDateTime(this.form.expirationTime);
    },
    delTicket() {
      console.log(this.selectRemark);

      const params = {
        strongDel: this.checkList.includes("1") ? 1 : 0,
        isUsed: this.checkList.includes("2") ? 1 : 0,
        notClaimed: this.checkList.includes("3") ? 1 : 0,
        remark: this.selectRemark,
      };

      this.$store
        .dispatch("user/deleteTicket", {
          params: params,
        })
        .then((res: any) => {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          this.fetchTickets();
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "error",
          });
        });
    },
    exportExcel() {
      requestByGet(
        "/excel",
        { num: 1, remark: this.selectRemark },
        "blob"
      ).then((res: any) => {
        console.log(res);
        downloadFile(
          res,
          "application/vnd.ms-excel",
          this.selectRemark + ".xlsx"
        );
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
// less 变量示例
@color-primary: #409eff;
@font-size-base: 14px;

.topBar {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
}

.demo-wrap {
  width: 100%;

  .demo-title {
    font-size: @font-size-base;
    color: @color-primary;
  }
}
</style>
